import React from 'react';
import ImpressionTimeline from '../../../../../../shared/designSystem/components/ImpressionTimeline';

// =============================================================================
// SignupImpressionsView — timeline of impressions that led to this sign-up.
//
// Renders inside the expanded row of the Sign Ups table. V2 facelift uses the
// shared `<ImpressionTimeline>` primitive; this component is now a thin
// adapter that unwraps the sign-up data structure and configures the
// primitive's mode — newest-first sort, Media meta row (since `media` here
// is a text descriptor, not a URL).
// =============================================================================

const SignupImpressionsView = ({ impressionsData }) => (
  <ImpressionTimeline
    impressions={impressionsData?.impressions}
    sort="newest"
    showMediaRow
  />
);

export default SignupImpressionsView;
